import { useFlags } from '@mint-lib/routing-context';

export const useSimplifiedHeadersMetaFF = () => {
  const ff = useFlags('@mint/arm', ['simplifiedHeadersMeta']);

  return ff.simplifiedHeadersMeta.enabled;
};
